import { render } from "./App.vue?vue&type=template&id=07caddc8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=07caddc8&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__